import { render } from "./VAppContent.vue?vue&type=template&id=f116d99c"
const script = {}

import "./VAppContent.vue?vue&type=style&index=0&id=f116d99c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__